"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const transform = property => (from, to) => (0, _styledComponents.keyframes)(["from{", ":", ";}to{", ":", ";}"], property, from, property, to);
const slideDown = property => function (from, to) {
  let end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : to;
  return (0, _styledComponents.keyframes)(["0%{", ":", ";}99%{", ":", ";}100%{", ":", ";}"], property, from, property, to, property, end);
};
const animation = props => (0, _styledComponents.css)(["", " 1s ease-in-out 2s forwards,", " 1s ease-in-out 2s forwards,", " 1s ease-in-out 2s forwards,", " 1s ease-in-out 3.2s forwards;& *{animation:", " 1s ease-in-out 3s forwards;}& > a div{animation:", " 1s ease-in-out 3s forwards;}& > a svg{animation:", " 1s ease-in-out 3s forwards;}& > a div{animation:", " 1s ease-in-out 3s forwards;}"], slideDown('height')(`${props.animationHeightBefore}px`, `${props.animationHeightAfter}px`, 'auto'), transform('padding-bottom')(`${props.animationPaddingBottomBefore}px`, `${props.animationPaddingBottomAfter}px`), transform('padding-top')(`${props.animationPaddingTopBefore}px`, `${props.animationPaddingTopAfter}px`), transform('background')(props.animationBackgroundColorBefore, props.animationBackgroundColorAfter), transform('color')(props.animationColorBefore, props.animationColorAfter), transform('color')(props.animationDivColorBefore, props.animationDivColorAfter), transform('fill')(props.animationFillColorBefore, props.animationFillColorAfter), transform('color')(props.animationFillColorBefore, props.animationFillColorAfter));
const ToastContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Toast__ToastContainer",
  componentId: "components-web__sc-p78jdh-0"
})(["display:flex;justify-content:center;align-items:center;flex-wrap:wrap;padding-left:", "px;padding-right:", "px;background:", ";gap:", ";height:0;overflow:hidden;animation:", ";"], _ref => {
  let {
    padding
  } = _ref;
  return padding;
}, _ref2 => {
  let {
    padding
  } = _ref2;
  return padding;
}, _ref3 => {
  let {
    containerBackgroundColor
  } = _ref3;
  return containerBackgroundColor;
}, _ref4 => {
  let {
    containerGap
  } = _ref4;
  return containerGap;
}, animation);
const Toast = /*#__PURE__*/_react.default.forwardRef((_ref5, ref) => {
  let {
    toast,
    copy,
    headline,
    link,
    tokens,
    variant = {},
    ...rest
  } = _ref5;
  // viewport hook added to work adjust the padding to different sizes
  const viewport = (0, _componentsBase.useViewport)();
  const {
    containerBackgroundColor,
    containerGap,
    animationHeightBefore,
    animationHeightAfter,
    animationPaddingBottomBefore,
    animationPaddingBottomAfter,
    animationPaddingTopBefore,
    animationPaddingTopAfter,
    animationBackgroundColorBefore,
    animationBackgroundColorAfter,
    animationColorBefore,
    animationColorAfter,
    chevronlinkFontWeight,
    ...extraTokens
  } = (0, _componentsBase.useThemeTokens)('Toast', tokens, variant, {
    viewport
  });

  // inherit ChevronLink tokens for animation colors
  const {
    color: chevronDefaultColor
  } = (0, _componentsBase.useThemeTokens)('ChevronLink', {}, {});
  const {
    color: chevronInverseColor
  } = (0, _componentsBase.useThemeTokens)('ChevronLink', {}, {
    inverse: true
  });
  if (!toast) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ToastContainer, {
    containerBackgroundColor: containerBackgroundColor,
    containerGap: containerGap,
    animationHeightBefore: animationHeightBefore,
    animationHeightAfter: animationHeightAfter,
    animationPaddingBottomBefore: animationPaddingBottomBefore,
    animationPaddingBottomAfter: animationPaddingBottomAfter,
    animationPaddingTopBefore: animationPaddingTopBefore,
    animationPaddingTopAfter: animationPaddingTopAfter,
    animationBackgroundColorBefore: animationBackgroundColorBefore,
    animationBackgroundColorAfter: animationBackgroundColorAfter,
    animationColorBefore: animationColorBefore,
    animationColorAfter: animationColorAfter,
    animationFillColorBefore: chevronInverseColor,
    animationFillColorAfter: chevronDefaultColor,
    ref: ref,
    ...extraTokens,
    ...selectProps(rest),
    children: [headline && /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
      variant: {
        bold: true,
        inverse: true
      },
      children: headline
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Spacer, {
      space: 2,
      direction: "row"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
      variant: {
        inverse: true
      },
      children: copy
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Spacer, {
      space: 2,
      direction: "row"
    }), link && /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.ChevronLink, {
      variant: {
        inverse: true
      },
      tokens: {
        blockFontWeight: chevronlinkFontWeight
      },
      href: link.href,
      LinkRouter: link.LinkRouter,
      linkRouterProps: link.linkRouterProps,
      children: link.text
    })]
  });
});
Toast.displayName = 'Toast';
Toast.propTypes = {
  ...selectedSystemPropTypes,
  tokens: (0, _componentsBase.getTokensPropType)('Toast'),
  /**
   * If true, the toast will be displayed
   */
  toast: _propTypes.default.bool,
  /**
   * The copy to display in the toast
   */
  copy: _propTypes.default.string.isRequired,
  /**
   * The headline to display in the toast (before copy)
   */
  headline: _propTypes.default.string,
  /**
   * The link to display in the toast (after copy)
   */
  link: _propTypes.default.shape({
    href: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired,
    LinkRouter: _componentsBase.withLinkRouter.propTypes?.LinkRouter,
    linkRouterProps: _componentsBase.withLinkRouter.propTypes?.linkRouterProps
  })
};
var _default = exports.default = Toast;